import React, { useState } from 'react';
import {
  Table, Card, Button, Space, Typography, Form, DatePicker,
  Tag, Select, message, Modal, Statistic, Row, Col, Descriptions,
  Drawer, InputNumber, Radio, Alert, Input, Tooltip
} from 'antd';
import { ReloadOutlined, DownloadOutlined, FileTextOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

// ══════════════════════════════════════════════
//  Mock 数据
// ══════════════════════════════════════════════
// TODO: 联调时替换为接口数据
// 列表行按 App + 币种 汇总；countries 明细按 国家 拆解
const MOCK_EXPEND = [
  {
    key: '1', billDate: '2026-08-01',
    targetEntName: '杭州智联科技有限公司', targetEntId: 'test-ent-001',
    appName: '智能家居控制-iOS-海外', appId: 'test-app-001',
    totalRevenue: '¥32,000.00',
    activeNum: 320, activeDenom: 1024,
    ratio: 80, customCountryCount: 2,
    currency: 'CNY', amount: 8000.00,
    billType: 'system', remark: '',
    countries: [
      { country: '美国', activeNum: 120, activeDenom: 400, ratio: 90, amount: 1200.00, currency: 'CNY' },
      { country: '日本', activeNum: 80, activeDenom: 300, ratio: 80, amount: 640.00, currency: 'CNY' },
      { country: '韩国', activeNum: 120, activeDenom: 324, ratio: 80, amount: 640.00, currency: 'CNY' },
    ],
  },
  {
    key: '2', billDate: '2026-08-01',
    targetEntName: '成都云视科技有限公司', targetEntId: 'test-ent-002',
    appName: '智能家居控制-Android-国内', appId: 'test-app-001',
    totalRevenue: '¥18,000.00',
    activeNum: 256, activeDenom: 800,
    ratio: 60, customCountryCount: 0,
    currency: 'CNY', amount: 4800.00,
    billType: 'system', remark: '',
    countries: [
      { country: '中国', activeNum: 256, activeDenom: 800, ratio: 60, amount: 4800.00, currency: 'CNY' },
    ],
  },
  {
    key: '3', billDate: '2026-07-01',
    targetEntName: '杭州智联科技有限公司', targetEntId: 'test-ent-001',
    appName: '云视监控-Android-海外', appId: 'test-app-002',
    totalRevenue: '$8,000.00',
    activeNum: 180, activeDenom: 600,
    ratio: 100, customCountryCount: 0,
    currency: 'USD', amount: 2400.00,
    billType: 'system', remark: '',
    countries: [
      { country: '美国', activeNum: 100, activeDenom: 350, ratio: 100, amount: 1400.00, currency: 'USD' },
      { country: '德国', activeNum: 80, activeDenom: 250, ratio: 100, amount: 1000.00, currency: 'USD' },
    ],
  },
  {
    key: '4', billDate: '2026-07-01',
    targetEntName: '广州云联物联网有限公司', targetEntId: 'test-ent-003',
    appName: '智能家居控制-iOS-国内', appId: 'test-app-001',
    totalRevenue: '¥28,000.00',
    activeNum: 128, activeDenom: 1024,
    ratio: 30, customCountryCount: 0,
    currency: 'CNY', amount: 960.00,
    billType: 'system', remark: '',
    countries: [
      { country: '中国', activeNum: 128, activeDenom: 1024, ratio: 30, amount: 960.00, currency: 'CNY' },
    ],
  },
  {
    key: '5', billDate: '2026-08-03',
    targetEntName: '杭州智联科技有限公司', targetEntId: 'test-ent-001',
    appName: '智能家居控制-iOS-海外', appId: 'test-app-001',
    totalRevenue: '—',
    activeNum: 0, activeDenom: 0,
    ratio: null, customCountryCount: 0,
    currency: 'CNY', amount: -500.00,
    billType: 'adjust', remark: '7月账单多计，冲回差额',
    countries: [],
  },
];

const MOCK_ENT_OPTIONS = [
  { value: 'test-ent-001', label: '杭州智联科技有限公司 (test-ent-001)' },
  { value: 'test-ent-002', label: '成都云视科技有限公司 (test-ent-002)' },
  { value: 'test-ent-003', label: '广州云联物联网有限公司 (test-ent-003)' },
];

const BILL_TYPE_MAP = { system: '系统出账', adjust: '人工冲账' };

const Expend = () => {
  const [dataSource, setDataSource] = useState(MOCK_EXPEND);
  const [filterEnt, setFilterEnt] = useState(undefined);
  const [filterDate, setFilterDate] = useState([]);
  const [adjustVisible, setAdjustVisible] = useState(false);
  const [adjustForm] = Form.useForm();

  const [exportVisible, setExportVisible] = useState(false);
  const [exportEnt, setExportEnt] = useState(undefined);
  const [exportMonth, setExportMonth] = useState(null);
  const [exportPreview, setExportPreview] = useState(null);

  const [detailVisible, setDetailVisible] = useState(false);
  const [detailRecord, setDetailRecord] = useState(null);

  const filteredData = dataSource.filter((r) => {
    if (filterEnt && r.targetEntId !== filterEnt) return false;
    if (filterDate && filterDate.length === 2) {
      const bill = new Date(r.billDate).getTime();
      if (bill < filterDate[0].startOf('day').valueOf() || bill > filterDate[1].endOf('day').valueOf()) return false;
    }
    return true;
  });

  const totalCNY = filteredData.filter((r) => r.currency === 'CNY').reduce((sum, r) => sum + (r.amount || 0), 0);
  const totalUSD = filteredData.filter((r) => r.currency === 'USD').reduce((sum, r) => sum + (r.amount || 0), 0);

  const handleExport = () => {
    const ent = MOCK_ENT_OPTIONS.find((e) => e.value === exportEnt);
    if (!exportEnt || !exportMonth) return;
    setExportPreview({
      entName: ent?.label || '',
      month: exportMonth.format('YYYY-MM'),
      totalCNY: 12800.00,
      totalUSD: 0,
    });
  };

  const confirmExport = () => {
    setExportVisible(false);
    setExportPreview(null);
    setExportEnt(undefined);
    setExportMonth(null);
    message.success('月账单导出中，请稍候...');
  };

  const handleAdjustSubmit = async () => {
    try {
      const values = await adjustForm.validateFields();
      const ent = MOCK_ENT_OPTIONS.find((e) => e.value === values.targetEnt);
      const amount = values.direction === 'positive' ? values.amount : -values.amount;
      const newRecord = {
        key: `adj-${Date.now()}`,
        billDate: values.billDate.format('YYYY-MM-DD'),
        targetEntName: ent?.label?.split(' ')[0] || '',
        targetEntId: values.targetEnt,
        appName: '—',
        appId: '—',
        totalRevenue: '—',
        activeNum: 0,
        activeDenom: 0,
        ratio: null,
        customCountryCount: 0,
        currency: 'CNY',
        amount,
        billType: 'adjust',
        remark: values.remark || '',
        countries: [],
      };
      setDataSource((prev) => [newRecord, ...prev]);
      message.success('冲账记录已添加');
      setAdjustVisible(false);
      adjustForm.resetFields();
    } catch {
      // validation failed
    }
  };

  const columns = [
    { title: '账单日期', dataIndex: 'billDate', width: 110 },
    { title: '分润对象', dataIndex: 'targetEntName', width: 150, render: (text, r) => <div><Text strong>{text}</Text><br /><Text type="secondary" style={{ fontSize: 12 }}>{r.targetEntId}</Text></div> },
    { title: '分润 App', dataIndex: 'appName', width: 170, render: (text, r) => <div><Text>{text}</Text><br /><Text type="secondary" style={{ fontSize: 12 }}>{r.appId}</Text></div> },
    { title: '我的总收益', dataIndex: 'totalRevenue', width: 120, render: (v) => v === '—' ? <span style={{ color: '#ccc' }}>—</span> : <Text>{v}</Text> },
    { title: <Space size={4}>活跃设备数<Tooltip title="下级活跃 / 设备总活跃"><Text type="secondary" style={{ fontSize: 12, cursor: 'help' }}>ⓘ</Text></Tooltip></Space>, key: 'active', width: 130,
      render: (_, r) => r.activeDenom > 0
        ? <Text>{r.activeNum}<Text type="secondary" style={{ fontSize: 12 }}>/{r.activeDenom}</Text></Text>
        : <span style={{ color: '#ccc' }}>-</span> },
    { title: '分润比例', key: 'ratio', width: 110,
      render: (_, r) => r.ratio != null
        ? <Space size={4}>{r.ratio}%{r.customCountryCount > 0 && <Tooltip title="该 App 存在自定义国家比例，详情见明细抽屉"><Tag color="orange" style={{ border: 'none', cursor: 'pointer' }}>自定义{r.customCountryCount}国</Tag></Tooltip>}</Space>
        : <span style={{ color: '#ccc' }}>-</span> },
    { title: '币种', dataIndex: 'currency', width: 70, render: (v) => <Tag color={v === 'CNY' ? 'green' : 'blue'} style={{ border: 'none' }}>{v}</Tag> },
    { title: '分润金额', dataIndex: 'amount', width: 130,
      render: (v, r) => <Text strong style={{ color: v < 0 ? '#ff4d4f' : '#1677ff' }}>{r.currency === 'CNY' ? '¥' : '$'}{Math.abs(v).toLocaleString()}</Text> },
    { title: '出账方式', dataIndex: 'billType', width: 105,
      render: (v, r) => v === 'adjust' && r.remark
        ? <Tooltip title={r.remark}><Tag color="orange" style={{ border: 'none', cursor: 'pointer' }}>人工冲账</Tag></Tooltip>
        : <Tag color={v === 'system' ? 'blue' : 'orange'} style={{ border: 'none' }}>{BILL_TYPE_MAP[v]}</Tag> },
    {
      title: '操作', key: 'action', width: 100, fixed: 'right',
      render: (_, r) => <Button type="link" size="small" icon={<FileTextOutlined />} onClick={() => { setDetailRecord(r); setDetailVisible(true); }}>查看明细</Button>,
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={4} style={{ margin: 0 }}>分润支出</Title>
        <Space>
          <Button icon={<DownloadOutlined />} onClick={() => setExportVisible(true)}>导出月账单</Button>
          <Button
            style={{ background: '#fffbe6', borderColor: '#ffe58f', color: '#d48806' }}
            onClick={() => { adjustForm.resetFields(); setAdjustVisible(true); }}
          >
            人工冲账
          </Button>
        </Space>
      </div>

      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
            <Statistic title="分润总额（¥）" value={totalCNY} precision={2} prefix="¥" valueStyle={{ color: '#1677ff', fontWeight: 'bold' }} />
          </Card>
        </Col>
        <Col span={12}>
          <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
            <Statistic title="分润总额（$）" value={totalUSD} precision={2} prefix="$" valueStyle={{ color: '#52c41a', fontWeight: 'bold' }} />
          </Card>
        </Col>
      </Row>

      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Form layout="inline">
          <Form.Item label="分润对象" style={{ marginBottom: 0 }}>
            <Select placeholder="选择企业" allowClear showSearch optionFilterProp="children" style={{ width: 240 }} value={filterEnt} onChange={setFilterEnt}>
              {MOCK_ENT_OPTIONS.map((e) => <Option key={e.value} value={e.value}>{e.label}</Option>)}
            </Select>
          </Form.Item>
          <Form.Item label="账单日期" style={{ marginBottom: 0 }}>
            <RangePicker value={filterDate} onChange={setFilterDate} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button icon={<ReloadOutlined />} onClick={() => { setFilterEnt(undefined); setFilterDate([]); }}>重置</Button>
          </Form.Item>
        </Form>
      </Card>

      <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="key"
          bordered={false}
          scroll={{ x: 1250 }}
          locale={{ emptyText: '暂无分润支出账单' }}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
        />
      </Card>

      {/* 明细抽屉（国家拆解） */}
      <Drawer
        title="账单明细（国家拆解）"
        open={detailVisible}
        onClose={() => setDetailVisible(false)}
        width={640}
      >
        {detailRecord && (
          <>
            <Descriptions bordered column={1} size="small" style={{ marginBottom: 24 }}>
              <Descriptions.Item label="账单日期">{detailRecord.billDate}</Descriptions.Item>
              <Descriptions.Item label="分润对象">{detailRecord.targetEntName}（{detailRecord.targetEntId}）</Descriptions.Item>
              <Descriptions.Item label="分润 App">{detailRecord.appName}（{detailRecord.appId}）</Descriptions.Item>
              <Descriptions.Item label="我的总收益">{detailRecord.totalRevenue}</Descriptions.Item>
              <Descriptions.Item label="出账方式">
                <Tag color={detailRecord.billType === 'system' ? 'blue' : 'orange'} style={{ border: 'none' }}>{BILL_TYPE_MAP[detailRecord.billType]}</Tag>
              </Descriptions.Item>
              {detailRecord.remark && <Descriptions.Item label="备注">{detailRecord.remark}</Descriptions.Item>}
            </Descriptions>

            {detailRecord.billType === 'system' && detailRecord.countries.length > 0 ? (
              <>
                <div style={{ marginBottom: 8 }}><Text strong>国家收益明细（{detailRecord.currency}）</Text></div>
                <Table
                  size="small"
                  rowKey="country"
                  dataSource={detailRecord.countries}
                  pagination={false}
                  columns={[
                    { title: '国家', dataIndex: 'country', width: 100 },
                    { title: '活跃设备数', key: 'active', width: 140,
                      render: (_, c) => <Text>{c.activeNum}<Text type="secondary" style={{ fontSize: 12 }}>/{c.activeDenom}</Text></Text> },
                    { title: '分润比例', dataIndex: 'ratio', width: 90, render: (v) => <Text style={{ color: '#1677ff' }}>{v}%</Text> },
                    { title: '分润金额', dataIndex: 'amount', width: 130, align: 'right',
                      render: (v, c) => <Text strong>{c.currency === 'CNY' ? '¥' : '$'}{Math.abs(v).toLocaleString()}</Text> },
                  ]}
                />
                <div style={{ marginTop: 16, textAlign: 'right' }}>
                  <Text type="secondary">合计：</Text>
                  <Text strong style={{ color: '#1677ff', fontSize: 16 }}>
                    {detailRecord.currency === 'CNY' ? '¥' : '$'}{Math.abs(detailRecord.amount).toLocaleString()}
                  </Text>
                </div>
              </>
            ) : (
              <Text type="secondary">该记录为人工冲账，无国家明细。</Text>
            )}
          </>
        )}
      </Drawer>

      {/* 导出月账单 Modal */}
      <Modal title="导出月账单" open={exportVisible} onCancel={() => { setExportVisible(false); setExportPreview(null); }} footer={null} width={500}>
        {!exportPreview ? (
          <>
            <Form layout="vertical" style={{ marginTop: 16 }}>
              <Form.Item label="分润对象">
                <Select placeholder="选择企业" allowClear showSearch optionFilterProp="children" value={exportEnt} onChange={setExportEnt}>
                  {MOCK_ENT_OPTIONS.map((e) => <Option key={e.value} value={e.value}>{e.label}</Option>)}
                </Select>
              </Form.Item>
              <Form.Item label="账单月份">
                <DatePicker picker="month" value={exportMonth} onChange={setExportMonth} style={{ width: '100%' }} placeholder="选择月份" />
              </Form.Item>
            </Form>
            <div style={{ textAlign: 'right', marginTop: 16 }}>
              <Button style={{ marginRight: 8 }} onClick={() => setExportVisible(false)}>取消</Button>
              <Button type="primary" disabled={!exportEnt || !exportMonth} onClick={handleExport}>查询预览</Button>
            </div>
          </>
        ) : (
          <>
            <Descriptions bordered column={1} size="small" style={{ marginTop: 16, marginBottom: 24 }}>
              <Descriptions.Item label="企业">{exportPreview.entName}</Descriptions.Item>
              <Descriptions.Item label="月份">{exportPreview.month}</Descriptions.Item>
              <Descriptions.Item label="分润总额（¥）">¥{exportPreview.totalCNY.toLocaleString()}</Descriptions.Item>
              <Descriptions.Item label="分润总额（$）">${exportPreview.totalUSD.toLocaleString()}</Descriptions.Item>
            </Descriptions>
            <div style={{ textAlign: 'right' }}>
              <Button style={{ marginRight: 8 }} onClick={() => setExportPreview(null)}>返回</Button>
              <Button type="primary" icon={<DownloadOutlined />} onClick={confirmExport}>导出 Excel</Button>
            </div>
          </>
        )}
      </Modal>

      {/* 人工冲账 Drawer */}
      <Drawer
        title="人工冲账"
        width={520}
        open={adjustVisible}
        onClose={() => setAdjustVisible(false)}
        destroyOnClose
        footer={
          <div style={{ textAlign: 'right' }}>
            <Button style={{ marginRight: 8 }} onClick={() => setAdjustVisible(false)}>取消</Button>
            <Button type="primary" onClick={handleAdjustSubmit}>保存</Button>
          </div>
        }
      >
        <Alert type="warning" showIcon style={{ marginBottom: 16, borderRadius: 6 }} message="人工冲账将直接影响分润账单金额，请谨慎操作。" />
        <Form form={adjustForm} layout="vertical" initialValues={{ direction: 'positive' }}>
          <Form.Item name="targetEnt" label="分润对象" rules={[{ required: true, message: '请选择分润对象' }]}>
            <Select placeholder="选择设备企业" showSearch optionFilterProp="children">
              {MOCK_ENT_OPTIONS.map((e) => <Option key={e.value} value={e.value}>{e.label}</Option>)}
            </Select>
          </Form.Item>
          <Form.Item noStyle shouldUpdate={(p, c) => p.targetEnt !== c.targetEnt}>
            {({ getFieldValue }) => {
              const v = getFieldValue('targetEnt');
              return v ? <div style={{ marginTop: -16, marginBottom: 16 }}><Text type="secondary" style={{ fontSize: 12 }}>企业ID：{v}</Text></div> : null;
            }}
          </Form.Item>
          <Form.Item name="billDate" label="账单日期" rules={[{ required: true, message: '请选择账单日期' }]}>
            <DatePicker style={{ width: '100%' }} placeholder="请选择账单日期" />
          </Form.Item>
          <Form.Item name="direction" label="冲账方向" rules={[{ required: true }]}>
            <Radio.Group>
              <Radio value="positive">冲入正数（增加分润）</Radio>
              <Radio value="negative">冲入负数（扣减分润）</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item name="amount" label="金额（CNY）" rules={[{ required: true, message: '请输入金额' }]}>
            <InputNumber min={0.01} precision={2} prefix="¥" placeholder="请输入冲账金额" style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="remark" label="冲账原因">
            <Input.TextArea rows={3} placeholder="请输入冲账原因" maxLength={200} showCount />
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
};

export default Expend;
